<ssc-base-vertical-overlay (closed)="closed.emit()">
  <dap-lib-button
    (click)="closed.emit()"
    buttonSize="medium"
    class="close"
    variant="close"
    data-cy="button-close-overlay"
    data-analytics="overlay-close"
  ></dap-lib-button>

  <div class="container">
    <div>
      <h1 class="headline-1">{{ title }}</h1>
      <div class="content">
        <ng-content select="[content]"></ng-content>
      </div>
    </div>
  </div>
</ssc-base-vertical-overlay>
